import { configureStore } from '@reduxjs/toolkit'
import { rootReducer } from '@/app/store/rootReducer'
import { dynamicMiddleware } from './dynamicMiddleware'
import { authActions } from '@/platform/auth/model/authSlice'

export const store = configureStore({
  reducer: (state, action) => rootReducer(
    authActions.anonymous.match(action) || authActions.expired.match(action) ? undefined : state,
    action,
  ),
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(dynamicMiddleware.middleware),
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
